import React, { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginScreen from './components/auth/LoginScreen';
import SubjectSelector from './components/learning/SubjectSelector';
import FlashcardStudy from './components/learning/FlashcardStudy';
import QuizScreen from './components/quiz/QuizScreen';
import SubscriptionScreen from './components/subscriptions/SubscriptionScreen';
import ProfileScreen from './components/profile/ProfileScreen';
import LegalScreen from './components/legal/LegalScreen';
import YouTubeScreen from './components/youtube/YouTubeScreen';
import BottomNavigation from './components/layout/BottomNavigation';
import { Toaster } from './components/ui/sonner';

const AppContent = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const [activeTab, setActiveTab] = useState('learn');
  const [selectedSubject, setSelectedSubject] = useState(null);

  // Loading state
  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 rounded-full border-4 border-primary border-t-transparent animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground">Laden...</p>
        </div>
      </div>
    );
  }

  // Not authenticated - show login
  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  // Study mode - full screen flashcards
  if (selectedSubject) {
    return (
      <FlashcardStudy 
        subjectId={selectedSubject} 
        onBack={() => setSelectedSubject(null)} 
      />
    );
  }

  // Main app with bottom navigation
  return (
    <div className="min-h-screen bg-background">
      {/* Content based on active tab */}
      {activeTab === 'learn' && (
        <SubjectSelector onSelectSubject={setSelectedSubject} />
      )}
      {activeTab === 'quiz' && (
        <QuizScreen onBack={() => setActiveTab('learn')} />
      )}
      {activeTab === 'youtube' && <YouTubeScreen />}
      {activeTab === 'help' && <SubscriptionScreen />}
      {activeTab === 'profile' && <ProfileScreen />}

      {/* Bottom Navigation */}
      <BottomNavigation activeTab={activeTab} onTabChange={setActiveTab} />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
      <Toaster position="top-center" />
    </AuthProvider>
  );
}

export default App;
